import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51397385"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-profile" }
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_Image = _resolveComponent("Image")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_DxpOmsInstanceNavigator = _resolveComponent("DxpOmsInstanceNavigator")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_DxpAppVersionInfo = _resolveComponent("DxpAppVersionInfo")!
  const _component_DxpTimeZoneSwitcher = _resolveComponent("DxpTimeZoneSwitcher")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_menu_button, { slot: "start" }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate("Settings")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, { lines: "full" }, {
                  default: _withCtx(() => [
                    (_ctx.userProfile?.partyImageUrl)
                      ? (_openBlock(), _createBlock(_component_ion_avatar, {
                          key: 0,
                          slot: "start"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Image, {
                              src: _ctx.userProfile.partyImageUrl
                            }, null, 8, ["src"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_card_header, { class: "ion-no-padding ion-padding-vertical" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_subtitle, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.userProfile?.userLoginId), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.userProfile?.partyName), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_button, {
                  color: "danger",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.translate("Logout")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_button, {
                  "standalone-hidden": !_ctx.hasPermission(_ctx.Actions.APP_PWA_STANDALONE_ACCESS),
                  fill: "outline",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToLaunchpad()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.translate("Go to Launchpad")) + " ", 1),
                    _createVNode(_component_ion_icon, {
                      slot: "end",
                      icon: _ctx.openOutline
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["standalone-hidden"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.translate('OMS')), 1)
          ]),
          _createElementVNode("section", null, [
            _createVNode(_component_DxpOmsInstanceNavigator),
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("Product Store")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("Store")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.translate("A store represents a company or a unique catalog of products. If your OMS is connected to multiple eCommerce stores sellling different collections of products, you may have multiple Product Stores set up in HotWax Commerce.")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, { lines: "none" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_select, {
                      label: _ctx.translate('Select store'),
                      interface: "popover",
                      value: _ctx.currentEComStore.productStoreId,
                      onIonChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setEComStore($event)))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.userProfile ? _ctx.userProfile.stores : []), (store) => {
                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                            key: store.productStoreId,
                            value: store.productStoreId
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(store.storeName), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["label", "value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("Shopify Config")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("eCommerce")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.translate('eCommerce stores are directly connected to one Shop Config. If your OMS is connected to multiple eCommerce stores selling the same catalog operating as one Company, you may have multiple Shop Configs for the selected Product Store.')), 1)
                  ]),
                  _: 1
                }),
                (_ctx.shopifyConfigs.length > 0)
                  ? (_openBlock(), _createBlock(_component_ion_item, {
                      key: 0,
                      lines: "none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_select, {
                          label: _ctx.translate('Select eCommerce'),
                          interface: "popover",
                          value: _ctx.currentShopifyConfig?.shopifyConfigId,
                          onIonChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setShopifyConfig($event)))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shopifyConfigs, (shopifyConfig) => {
                              return (_openBlock(), _createBlock(_component_ion_select_option, {
                                key: shopifyConfig.shopifyConfigId,
                                value: shopifyConfig.shopifyConfigId
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(shopifyConfig.name ? shopifyConfig.name : shopifyConfig.shopifyConfigName), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["label", "value"])
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_ion_item, {
                      key: 1,
                      lines: "none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate("No eCommerce stores connected to", { eCommStore : _ctx.currentEComStore.storeName ? _ctx.currentEComStore.storeName : _ctx.currentEComStore.productStoreId })), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            })
          ]),
          _hoisted_3,
          _createVNode(_component_DxpAppVersionInfo),
          _createElementVNode("section", null, [
            _createVNode(_component_DxpTimeZoneSwitcher, { onTimeZoneUpdated: _ctx.timeZoneUpdated }, null, 8, ["onTimeZoneUpdated"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}